import { SlingoLang } from "@lib/titan2-slingo/dist/game/view/abstract/lang/SlingoLang";
/**
 * GameLang.ts
 */
export class GameLang extends SlingoLang {
}
GameLang.RESULT = "GameLang.RESULT";
GameLang.AVAILABLE_WIN_LABEL0 = "GameLang.AVAILABLE_WIN_LABEL0";
GameLang.AVAILABLE_WIN_LABEL1 = "GameLang.AVAILABLE_WIN_LABEL1";
GameLang.AVAILABLE_WIN_LABEL2 = "GameLang.AVAILABLE_WIN_LABEL2";
GameLang.COPYRIGHT = "GameLang.LEGAL_GMR";
GameLang.PARAM_GAME = "{param.game}";
GameLang.PARAM_FEATURE_MULTIPLIER = "{param.feature.multiplier}";
GameLang.CASH_BONUS = "{param.ladder.cash}";
GameLang.X_CASH = "{param.ladder.current.multiplier}";
GameLang.PARAM_SPINS = "{param.ladder.spins}";
GameLang.CURRENCY = "{currency}";
GameLang.LOADER_GUIDE_BODY_0 = "GameLang.LOADER_GUIDE_BODY_0";
GameLang.LOADER_GUIDE_BODY_1 = "GameLang.LOADER_GUIDE_BODY_1";
GameLang.LOADER_GUIDE_BODY_2 = "GameLang.LOADER_GUIDE_BODY_2";
GameLang.LOADER_GUIDE_BODY_3_2 = "GameLang.LOADER_GUIDE_BODY_3_2";
GameLang.LOADER_GUIDE_BODY_3_1 = "GameLang.LOADER_GUIDE_BODY_3_1";
GameLang.LOADER_GUIDE_BODY_3_0 = "GameLang.LOADER_GUIDE_BODY_3_0";
GameLang.LEGAL_3P = "GameLang.LEGAL_3P";
GameLang.LEGAL_GMR = "GameLang.LEGAL_GMR";
GameLang.SLINGO_1 = "GameLang.SLINGO_1";
GameLang.SLINGO_2 = "GameLang.SLINGO_2";
GameLang.SLINGO_3 = "GameLang.SLINGO_3";
GameLang.SLINGO_4 = "GameLang.SLINGO_4";
GameLang.SLINGO_5 = "GameLang.SLINGO_5";
GameLang.SLINGO_6 = "GameLang.SLINGO_6";
GameLang.SLINGO_7 = "GameLang.SLINGO_7";
GameLang.SLINGO_8 = "GameLang.SLINGO_8";
GameLang.SLINGO_9 = "GameLang.SLINGO_9";
GameLang.SLINGO_10 = "GameLang.SLINGO_10";
GameLang.SLINGO_12 = "GameLang.SLINGO_12";
GameLang.SLINGO_SHORT_1 = "GameLang.SLINGO_SHORT_1";
GameLang.SLINGO_SHORT_2 = "GameLang.SLINGO_SHORT_2";
GameLang.SLINGO_SHORT_3 = "GameLang.SLINGO_SHORT_3";
GameLang.SLINGO_SHORT_4 = "GameLang.SLINGO_SHORT_4";
GameLang.SLINGO_SHORT_5 = "GameLang.SLINGO_SHORT_5";
GameLang.SLINGO_SHORT_6 = "GameLang.SLINGO_SHORT_6";
GameLang.SLINGO_SHORT_7 = "GameLang.SLINGO_SHORT_7";
GameLang.SLINGO_SHORT_8 = "GameLang.SLINGO_SHORT_8";
GameLang.SLINGO_SHORT_9 = "GameLang.SLINGO_SHORT_9";
GameLang.SLINGO_SHORT_10 = "GameLang.SLINGO_SHORT_10";
GameLang.SLINGO_SHORT_12 = "GameLang.SLINGO_SHORT_12";
GameLang.SLINGO_LADDER_AWARD_SPINS = "GameLang.SLINGO_LADDER_AWARD_SPINS";
GameLang.SLINGO_LADDER_AWARD_FREE_SPINS = "GameLang.SLINGO_LADDER_AWARD_FREE_SPINS";
GameLang.SLINGO_LADDER_AWARD_MULTIPLIER_CURRENT = "GameLang.SLINGO_LADDER_AWARD_MULTIPLIER_CURRENT";
GameLang.SLINGO_LADDER_AWARD_MULTIPLIER_WHEEL = "GameLang.SLINGO_LADDER_AWARD_MULTIPLIER_WHEEL";
GameLang.IDLE_0 = "GameLang.IDLE_0";
GameLang.IDLE_1 = "GameLang.IDLE_1";
GameLang.IDLE_2 = "GameLang.IDLE_2";
GameLang.IDLE_3 = "GameLang.IDLE_3";
GameLang.IDLE_4 = "GameLang.IDLE_4";
GameLang.IDLE_5 = "GameLang.IDLE_5";
GameLang.IDLE_6 = "GameLang.IDLE_6";
GameLang.IDLE_7 = "GameLang.IDLE_7";
GameLang.PURCHASE_SPIN_0 = "GameLang.PURCHASE_SPIN_0";
GameLang.PURCHASE_SPIN_1 = "GameLang.PURCHASE_SPIN_1";
GameLang.AVAILABLE_WIN_0 = "GameLang.AVAILABLE_WIN_0";
GameLang.AVAILABLE_WIN_1 = "GameLang.AVAILABLE_WIN_1";
GameLang.AVAILABLE_WIN_2 = "GameLang.AVAILABLE_WIN_2";
GameLang.AVAILABLE_WIN_PLUS = "GameLang.AVAILABLE_WIN_PLUS";
GameLang.COLLECT_BUTTON_WIN_0 = "GameLang.COLLECT_BUTTON_WIN_0";
GameLang.COLLECT_BUTTON_WIN_1 = "GameLang.COLLECT_BUTTON_WIN_1";
GameLang.COLLECT_BUTTON_WIN_2 = "GameLang.COLLECT_BUTTON_WIN_2";
GameLang.WIN_0 = "GameLang.WIN_0";
GameLang.WIN_1 = "GameLang.WIN_1";
GameLang.WIN_2 = "GameLang.WIN_2";
GameLang.WIN_3 = "GameLang.WIN_3";
GameLang.FEATURE_CELL = "GameLang.FEATURE_CELL";
GameLang.INSTANT_CELL = "GameLang.INSTANT_CELL";
GameLang.FREE_SPINS = "GameLang.FREE_SPINS";
GameLang.SPINS = "GameLang.PAY_TABLE_SPINS";
GameLang.SPIN = "ArcadeWheelLang.TOOLTIP_TEXT_WHEEL_WIN";
GameLang.RESULT_SCATTER = "GameLang.SCATTERS";
GameLang.RESULT_INSTANT = "GameLang.RESULT_INSTANT";
GameLang.WIN_LINE_MULTIPLIER = "GameLang.WIN_LINE_MULTIPLIER";
GameLang.SCATTER_MIN = "GameLang.SCATTER_MIN";
GameLang.SCATTER_MAX = "GameLang.SCATTER_MAX";
GameLang.SCATTER_GAME1 = "GameLang.SCATTER_GAME1";
GameLang.SCATTER_GAME2 = "GameLang.SCATTER_GAME2";
GameLang.SCATTER_GAME3 = "GameLang.SCATTER_GAME3";
GameLang.MINI = "GameLang.MINI";
GameLang.MINOR = "GameLang.MINOR";
GameLang.MAJOR = "GameLang.MAJOR";
GameLang.BIGWIN = "GameLang.BIGWIN";
GameLang.EPICWIN = "GameLang.EPICWIN";
GameLang.MEGAWIN = "GameLang.MEGAWIN";
GameLang.AUTO_WILD = "GameLang.AUTO_WILD";
GameLang.AUTO_SUPER_WILD = "GameLang.AUTO_SUPERWILD";
//# sourceMappingURL=GameLang.js.map